import {
    useState,
    useEffect
} from 'react';
import {
    Container,
    Box,
    Controls,
    User,
    LoadingProgress
} from './styled';
import {
    Search,
    Avatar
} from '../../../../../components';
import {
    FaAngleRight,
    FaAngleLeft,
    FaAngleDoubleRight,
    FaAngleDoubleLeft
} from "react-icons/fa";
import {
    createGroup,
    linkedUsersToGroup,
    removeLinkBetweenUsersAndGroup
} from '../../../../../service/serviceChat/groupService';
import coffee_time from '../../../../../assets/SVGs/coffee_time.svg';
import { toast } from 'react-toastify';

export function LinkUsersGroup({ group, usersAll, callback }) {

    const [options, setOptions] = useState({
        selected: [],
        left: [],
        right: []
    });
    const [loading, setLoading] = useState({
        inProgress: false,
        order: null
    });
    const [searchInAllUsers, setSearchInAllUsers] = useState('');
    const [searchInUsersGroup, setSearchInUsersGroup] = useState('');

    const mountOptions = () => {
        var usersGroup = group?.usuarios
        if (usersGroup) {
            const idSet = new Set(usersGroup.map(obj => obj.id));
            usersAll = usersAll.filter(obj => !idSet.has(obj.id))
            usersGroup = usersGroup.map(obj => ({ ...obj, isLinked: true }));
            setOptions({
                selected: [],
                left: usersAll,
                right: usersGroup
            });
        } else {
            setOptions({
                selected: [],
                left: usersAll,
                right: []
            });
        }
    };
    useEffect(() => {
        mountOptions()
        setSearchInAllUsers('')
        setSearchInUsersGroup('')
    }, [group]);

    const onWaitingTime = async (time, callback) => {
        const timeoutId = setTimeout(() => {
            callback();
        }, time);
        return () => clearTimeout(timeoutId);
    };

    const handleMoveAllLeft = () => {
        const keys = options.left.reduce((acc, obj) => {
            acc[obj.id] = true;
            return acc;
        }, {});
        const newLeft = options.left.concat(
            options.right.filter(objeto => !keys[objeto.id])
        );
        setOptions({
            selected: [],
            left: newLeft,
            right: [],
        });
    };
    const handleMAllRight = () => {
        const keys = options.right.reduce((acc, obj) => {
            acc[obj.id] = true;
            return acc;
        }, {});
        const niwRight = options.right.concat(
            options.left.filter(objeto => !keys[objeto.id])
        );
        setOptions({
            selected: [],
            left: [],
            right: niwRight
        });
    };
    const handleMoveRight = () => {
        const add = options.left.filter(
            item => options?.selected?.includes(item)
        );
        setOptions(prevState => ({
            left: options.left.filter(item => !options.selected?.includes(item)),
            right: [...prevState.right, ...add],
            selected: []
        }));
    };
    const handleMoveLeft = () => {
        const add = options.right.filter(
            item => options.selected?.includes(item)
        );
        setOptions(prevState => ({
            left: [...prevState.left, ...add],
            right: options.right.filter(item => !options.selected?.includes(item)),
            selected: []
        }));
    };
    const handleSelected = (e, item) => {
        if (e?.shiftKey) {
            setOptions(prevState => ({
                ...prevState,
                selected: prevState.selected?.includes(item)
                    ? prevState.selected.filter(selectedItem => selectedItem !== item)
                    : [...prevState.selected, item]
            }));
        } else {
            setOptions(prevState => ({ ...prevState, selected: [item] }))
        }
    };

    async function handleSave() {
        if (!group.id) {
            setLoading({
                inProgress: true,
                order: 1
            });
            if (!group?.name) {
                toast.warn(
                    `Por favor ! informe um nome para o setor`,
                    {
                        position: "top-center",
                        theme: "colored",
                    }
                );
                setLoading({
                    inProgress: false,
                    order: null
                });
                return
            };
            const {
                status_code,
                message,
                id
            } = await createGroup(group?.name);
            if (status_code !== 200) {
                toast.error(
                    `${message}`,
                    {
                        position: "top-center",
                        theme: "colored",
                    }
                );
                setLoading({
                    inProgress: false,
                    order: null
                });
                return
            }
            group.id = id;
        }
        setLoading({
            inProgress: true,
            order: 2
        })
        const { status_code } = await linkedUsersToGroup(
            group.id,
            options.right.map(user => user.id)
        );
        if (status_code === 200) {
            const removeLink = options.left
                .filter(item => item?.isLinked === true)
            if (removeLink) {
                const resp = await removeLinkBetweenUsersAndGroup(
                    group.id,
                    removeLink.map(user => user.id)
                );
                if (!resp) {
                    toast.error(
                        `Erro ao desvincular ${(removeLink.length === 1) 
                            ?'usuário'
                            :'usuários'
                        }`,
                        {
                            position: "top-center",
                            theme: "colored",
                        }
                    );
                    setLoading({
                        inProgress: false,
                        order: null
                    });
                    return
                }
            }
        }
        const alert = {
            typeAlert: (status_code === 200) ? 'success' : 'error',
            message: (status_code === 200)
                ? `Setor ${(group.id) ? 'atualizado' : 'criado'} com sucesso !`
                : `Erro ao configurar setor !`
        }
        onWaitingTime(
            2000,
            () => {
                toast[alert.typeAlert](
                    `${alert.message}`,
                    {
                        position: "top-center",
                        theme: "colored",
                    }
                );
                setLoading({
                    inProgress: false,
                    order: null
                });
                callback();
            }
        );
    };

    function onFilterAllUsers(user) {
        return user?.nomecompleto?.toLowerCase()
            ?.includes(searchInAllUsers?.toLocaleLowerCase())
            || user?.nomeusuario?.toLowerCase()
                ?.includes(searchInAllUsers?.toLocaleLowerCase());
    };
    function onFilterUsersGroup(user) {
        return user?.nomecompleto?.toLowerCase()
            ?.includes(searchInUsersGroup?.toLocaleLowerCase())
            || user?.nomeusuario?.toLowerCase()
                ?.includes(searchInUsersGroup?.toLocaleLowerCase());
    };


    return (
        <Container>
            <Box>
                <span>
                    {`Usuários`}
                </span>
                <Search
                    className="sehF"
                    value={searchInAllUsers}
                    onChange={(e) => setSearchInAllUsers(e.target.value)}
                    placeholder={`Buscar Usuário`}
                />
                <ul>
                    {options.left?.filter(onFilterAllUsers)?.sort(
                        (obj1, obj2) => obj1.nomecompleto.localeCompare(
                            obj2.nomecompleto, 'en',
                            { ignorePunctuation: true }
                        ))?.map(item =>
                            <li
                                key={item.id}
                                onClick={(e) => handleSelected(e, item)}
                                className={
                                    (options.selected?.includes(item))
                                        ? 'selected'
                                        : ''
                                }
                            >
                                <User>
                                    <Avatar
                                        className='avUs'
                                        name={item.nomecompleto}
                                    />
                                    <span className='name'>
                                        {item.nomecompleto}
                                    </span>
                                </User>
                            </li>
                        )}
                </ul>
            </Box>
            <Controls>
                <div>
                    <button onClick={() => handleMAllRight()}>
                        <FaAngleDoubleRight fontSize={'1.2rem'} />
                    </button>
                    <button onClick={() => handleMoveRight()}>
                        <FaAngleRight fontSize={'1.2rem'} />
                    </button>
                    <button onClick={() => handleMoveLeft()}>
                        <FaAngleLeft fontSize={'1.2rem'} />
                    </button>
                    <button onClick={() => handleMoveAllLeft()}>
                        <FaAngleDoubleLeft fontSize={'1.2rem'} />
                    </button>
                </div>
                <div>
                    <button
                        className={'save'}
                        onClick={() => handleSave()}>
                        {`Salvar`}
                    </button>
                </div>
            </Controls>
            <Box>
                <span>
                    {`Usuários no setor`}
                </span>
                <Search
                    className="sehF"
                    value={searchInUsersGroup}
                    onChange={(e) => setSearchInUsersGroup(e.target.value)}
                    placeholder={`Buscar Usuário`}
                />
                <ul>
                    {options.right?.filter(onFilterUsersGroup)?.sort(
                        (obj1, obj2) => obj1?.nomecompleto?.localeCompare(
                            obj2.nomecompleto, 'en',
                            { ignorePunctuation: true }
                        ))?.map(item =>
                            <li
                                key={item.id}
                                onClick={(e) => handleSelected(e, item)}
                                className={
                                    (options.selected?.includes(item))
                                        ? 'selected'
                                        : ''
                                }
                            >
                                <User>
                                    <Avatar
                                        className='avUs'
                                        name={item.nomecompleto}
                                    />
                                    <span className='name'>
                                        {item.nomecompleto}
                                    </span>
                                </User>
                            </li>
                        )}
                </ul>
            </Box>
            <LoadingProgress
                isOpen={(loading?.inProgress) ? 1 : 0}
            >
                <div>
                    <div>
                        <img
                            src={`${coffee_time}`}
                            alt=""
                        />
                    </div>
                    <div>
                        <span className='loader'></span>
                    </div>
                    <div>
                        <p>
                            {(loading.order === 1)
                                ? 'Criando Setor ...'
                                : 'Vinculando Usuário ...'
                            }
                        </p>
                    </div>
                </div>
            </LoadingProgress>
        </Container>
    )
}